import React, {ReactElement} from 'react';
import {useIntl} from 'react-intl';
import {cx} from '@emotion/css';
import CheckpointsContainer from '@fo/designSystem/Checkpoints/Container';
import {Icon} from '@fo/designSystem/Checkpoints/CheckpointItem';

import styles from './Checkpoints.styles';

function Checkpoints(): ReactElement {
  const {formatMessage} = useIntl();
  const data = [
    formatMessage({id: 'homepage.checkpoints.1'}),
    formatMessage({id: 'homepage.checkpoints.2'}),
    formatMessage({id: 'homepage.checkpoints.3'}),
    formatMessage({id: 'homepage.checkpoints.4'}),
  ];

  return <CheckpointsContainer className={cx(styles.homepageCheckpoints)} listItems={data} icon={Icon.TICKED_CIRCLE} />;
}

export default Checkpoints;
